module.exports = __webpack_public_path__ + "media/highclass/logo-a8c9846b.svg";